import { createSelector } from 'reselect';

const getConnectedHistory = ({ powertrainTools }) => {
    return powertrainTools?.connectedHistory;
};

const getConnectedHistoryData = ({ powertrainTools }) => {
    return powertrainTools?.connectedHistory?.data;
};

const getConnectedHistoryLoadingStatus = ({ powertrainTools }) => {
    return powertrainTools?.connectedHistory?.loadingStatus;
};

const getConnectedHistoryError = ({ powertrainTools }) => {
    return powertrainTools?.connectedHistory?.error;
};

const getConnectedHistoryLastQueryParams = ({ powertrainTools }) => {
    return powertrainTools?.connectedHistory?.lastQueryParams;
};

export const getModel = createSelector(
    [
        getConnectedHistory,
        getConnectedHistoryData,
        getConnectedHistoryLoadingStatus,
        getConnectedHistoryError,
        getConnectedHistoryLastQueryParams
    ],
    (
        connectedHistory,
        data,
        loadingStatus,
        error,
        lastQueryParams
    ) => {
        return {
            connectedHistory,
            data,
            loadingStatus,
            error,
            lastQueryParams
        };
    }
);
